import styles from './index.module.scss'
import { useEffect, useMemo, useRef, useState } from 'react';
import { Popover } from 'antd'
import Utils from '@utils/utils'
import { TYPETITLEMAP, IMAGE_TYPE, CLOTH_COLOR_TYPE, GENERATE_MODE, VIDEO_ORIENTATION, POSE_FANTASY_MODE, RELIGHT_MODE, MODEL_EXPRESSION, INPUT_IMAGE_TYPE, MODEL_PROVIDER } from '@utils/CONST'
import RefListModal from '../../../../../BatchProductImages/components/RefListModal'

const ModelLeftCom = (props) => {
    const { item, selectedInputImg, setSelectedInputImg } = props
    const refListModalRef = useRef(null)
    const getGenerateModeLabel = (mode, modelProvider) => {
        const isSotaModel = modelProvider == MODEL_PROVIDER.SOTA || modelProvider?.toLowerCase?.() == 'sota'
        if (isSotaModel) return mode == GENERATE_MODE.HQ ? '高品质模式4K' : '标准模式2K'
        return mode == GENERATE_MODE.HQ ? '高品质模式' : '标准模式'
    }
    const getCreativeImageModeLabel = (mode) => {
        return mode == GENERATE_MODE.HQ ? '4K' : '2K'
    }
    const formatModelProvider = (value) => {
        if (!value) return ''
        if (value == MODEL_PROVIDER.SOTA || value.toLowerCase?.() == 'sota') return '全能模型'
        if (value == MODEL_PROVIDER.ARCMUSE || value.toLowerCase?.() == 'arcmuse') return 'ArcMuse'
        return value
    }

    const title = (
        <div className={styles.section}>
            <p className={styles.headerTitle}>{(item?.imageType == IMAGE_TYPE.CLOTH_RECOLOR && item.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR) ? '自由换色' :
                (item?.imageType == IMAGE_TYPE.CLOTH_RECOLOR && item.mode == CLOTH_COLOR_TYPE.SIM_RECOLOR) ? '同款换色' :
                    TYPETITLEMAP[item?.imageType]}</p>
            <p className={styles.headerSubTitle}>{item?.projectName}</p>
            <p className={styles.headerSubTitle}>{item?.createdTime}</p>
        </div>
    )
    const mode = <div className={styles.section}><p className={styles.label}>生成模式</p><p className={styles.value}>{getGenerateModeLabel(item?.mode, item?.modelProvider || item?.attr?.modelProvider)}</p></div>
    const modelProviderValue = formatModelProvider(item?.modelProvider || item?.attr?.modelProvider)
    const modelProvider = modelProviderValue ? <div className={styles.section}><p className={styles.label}>模型选择</p><p className={styles.value}>{modelProviderValue}</p></div> : null
    const hdMode = <div className={styles.section}><p className={styles.label}>高清模式</p><p className={styles.value}>{getGenerateModeLabel(item?.hdMode, item?.modelProvider || item?.attr?.modelProvider)}</p></div>
    const orientation = <div className={styles.section}><p className={styles.label}>视频方向</p><p className={styles.value}>{(item?.orientation === VIDEO_ORIENTATION.REF || !item?.orientation) ? '与参考视频一致' : '与模特图一致'}</p></div>
    const duration = <div className={styles.section}><p className={styles.label}>视频时长</p><p className={styles.value}>{item?.duration == 10 ? '10秒' : '5秒'}</p></div>

    const promptTextRef = useRef(null)
    const [promptOverflow, setPromptOverflow] = useState(false)
    const [promptPopoverOpen, setPromptPopoverOpen] = useState(false)
    const promptText = useMemo(() => {
        return item?.prompt
    }, [item])

    const checkPromptOverflow = () => {
        const el = promptTextRef.current
        if (!el) {
            setPromptOverflow(false)
            return
        }

        const computedStyle = window.getComputedStyle(el)
        const measureEl = document.createElement('div')
        measureEl.textContent = promptText || ''
        measureEl.style.position = 'fixed'
        measureEl.style.left = '-9999px'
        measureEl.style.top = '0'
        measureEl.style.visibility = 'hidden'
        measureEl.style.pointerEvents = 'none'
        measureEl.style.zIndex = '-1'
        measureEl.style.boxSizing = 'border-box'
        measureEl.style.width = `${el.clientWidth}px`
        measureEl.style.fontSize = computedStyle.fontSize
        measureEl.style.fontWeight = computedStyle.fontWeight
        measureEl.style.fontFamily = computedStyle.fontFamily
        measureEl.style.lineHeight = computedStyle.lineHeight
        measureEl.style.letterSpacing = computedStyle.letterSpacing
        measureEl.style.wordBreak = computedStyle.wordBreak
        measureEl.style.whiteSpace = computedStyle.whiteSpace
        measureEl.style.padding = computedStyle.padding
        measureEl.style.border = computedStyle.border
        measureEl.style.display = 'block'
        measureEl.style.webkitLineClamp = 'unset'
        measureEl.style.setProperty('-webkit-line-clamp', 'unset')
        measureEl.style.setProperty('-webkit-box-orient', 'initial')
        measureEl.style.overflow = 'visible'

        document.body.appendChild(measureEl)
        const lineHeight = parseFloat(computedStyle.lineHeight) || 20
        const maxHeight = lineHeight * 4
        const fullHeight = measureEl.scrollHeight
        document.body.removeChild(measureEl)

        setPromptOverflow(fullHeight > maxHeight + 1)
    }

    useEffect(() => {
        let destroyed = false
        let frameId = 0
        const runCheck = () => {
            cancelAnimationFrame(frameId)
            frameId = requestAnimationFrame(() => {
                if (destroyed) return
                checkPromptOverflow()
            })
        }

        runCheck()

        const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(runCheck) : null
        if (promptTextRef.current && resizeObserver) {
            resizeObserver.observe(promptTextRef.current)
        }

        const handleResize = () => runCheck()
        window.addEventListener('resize', handleResize)

        if (document.fonts?.ready) {
            document.fonts.ready.then(() => {
                if (!destroyed) runCheck()
            })
        }

        return () => {
            destroyed = true
            cancelAnimationFrame(frameId)
            resizeObserver?.disconnect()
            window.removeEventListener('resize', handleResize)
        }
    }, [promptText])
    const prompt = (
        <div className={styles.promptWrap}>
            <div className={styles.promptTextWrap}>
                <p>描述：</p>
                <span ref={promptTextRef} className={styles.promptText}>{promptText}</span>
                {promptOverflow && (
                    <Popover
                        open={promptPopoverOpen}
                        onOpenChange={setPromptPopoverOpen}
                        trigger="hover"
                        placement="bottom"
                        content={<div className={styles.promptPopoverContent}>{promptText}</div>}
                    >
                        <span className={styles.viewAll}>查看全部</span>
                    </Popover>
                )}
            </div>
        </div>
    )
    const skinRefine = <div className={styles.section}><p className={styles.label}>肤质优化</p><p className={styles.value}>开启</p></div>
    const relight = <div className={styles.section}><p className={styles.label}>光影增强</p><p className={styles.value}>开启</p></div>
    const relightMode = <div className={styles.section}>
        <p className={styles.label}>光影模式</p>
        <p className={styles.value}>
            {
                item?.relightMode === RELIGHT_MODE.SKIN ? "标准模式" :
                    item?.relightMode === RELIGHT_MODE.PORTRAIT ? "人像模式" : "反光板模式"
            }
        </p>
    </div>
    const relightMode2 = <div className={styles.section}>
        <p className={styles.label}>光影模式</p>
        <p className={styles.value}>
            {
                item?.mode === RELIGHT_MODE.SKIN ? "标准模式" :
                    item?.mode === RELIGHT_MODE.PORTRAIT ? "人像模式" : "反光板模式"
            }
        </p>
    </div>
    const resolutionAlignTitle = item?.resolutionAlign &&
        <div className={styles.section}><p className={styles.label}>比例参照</p><p className={styles.value}>{item?.resolutionAlign == 'bkg' ? "参考图比例" : item?.resolutionAlign == 'input' ? "上传图比例" : null}</p></div>
    const recolor = (
        <div className={styles.section}>
            <p className={styles.label}>目标颜色</p>
            <p className={styles.value}>{item.color}</p>
            <div className={styles.imageList}>
                <span style={{
                    display: 'inline-block',
                    backgroundColor: item.color,
                    width: '54px',
                    height: '54px',
                    borderRadius: '4px',
                }}>
                </span>
            </div>
        </div>
    )
    const simReColor = (
        <div className={styles.section}>
            <p className={styles.label}>{item?.mode == INPUT_IMAGE_TYPE.MATERIAL ? '面料图' : '衣服图'}</p>
            <div className={styles.imageList}>
                {
                    item?.clothes?.split(',').map((inputItem) => {
                        return <img
                            key={inputItem}
                            onClick={() => setSelectedInputImg(inputItem)}
                            className={selectedInputImg == inputItem ? styles.active : ''}
                            src={Utils.getImgThumbnail(inputItem)} alt="" />
                    })
                }
            </div>
        </div>
    )
    const modelEmoji = <div className={styles.section}><p className={styles.label}>模特表情</p><p className={styles.value}>{item?.emoji === MODEL_EXPRESSION.SRC ? '按原模特' : '按模特参考图'}</p></div>

    const inputImg = (
        <div className={styles.section}>
            <p className={styles.label}>
                {item?.imageType == IMAGE_TYPE.CLOTHES ? '衣服图' : item?.imageType == IMAGE_TYPE.IMAGE_TO_VIDEO ? '首帧图' : '输入图'}
                <span style={{ marginLeft: '12px' }}>{(item?.imageType == IMAGE_TYPE.IMAGE_TO_VIDEO && item?.imageTail) && '尾帧图'}</span>
            </p>
            <div className={styles.imageList}>
                {
                    item?.inputImage?.split(',').map((inputItem) => {
                        return <img
                            className={((selectedInputImg == inputItem && item?.inputImage?.split(',').length > 1) ? styles.active : '')}
                            key={inputItem}
                            onClick={() => setSelectedInputImg(inputItem)}
                            src={Utils.getImgThumbnail(inputItem)} alt="" />
                    })
                }
                {
                    item?.imageType == IMAGE_TYPE.IMAGE_TO_VIDEO && item?.imageTail && <img
                        key={item?.imageTail}
                        onClick={() => setSelectedInputImg(item?.imageTail)}
                        className={selectedInputImg == item?.imageTail ? styles.active : ''}
                        src={Utils.getImgThumbnail(item?.imageTail)} alt="" />
                }
            </div>
        </div>
    )
    const poseImg = (
        <div className={styles.section}>
            <p className={styles.label}>试衣参考图</p>
            <div className={styles.imageList}>
                <img src={Utils.getImgThumbnail(item?.pose?.url)} alt="" />
            </div>
        </div>
    )
    const poseTryonImg = (
        item?.mode == POSE_FANTASY_MODE.REFERENCEMODE ? <div className={styles.section}>
            <p className={styles.label}>{item?.poseRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <div className={styles.imageList}>
                <img src={Utils.getImgThumbnail(item?.poseRef?.url)} alt="" />
            </div>
        </div> : prompt
    )
    const glassesTryonImg = (
        <div className={styles.section}>
            <p className={styles.label}>{((item?.imageType == IMAGE_TYPE.NECKLACE_TRYON ? item?.jewelryRef?.custom : item?.glassesRef?.custom) ?? item?.glassesRef?.custom) ? "自定义参考图" : '预设参考图'}</p>
            <div className={styles.imageList}>
                <img src={Utils.getImgThumbnail((item?.imageType == IMAGE_TYPE.NECKLACE_TRYON ? item?.jewelryRef?.url : item?.glassesRef?.url) || item?.glassesRef?.url)} alt="" />
            </div>
        </div>
    )
    const simTryonImg = (
        <div className={styles.section}>
            <p className={styles.label}>{item?.poseRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <div className={styles.imageList}>
                <img src={Utils.getImgThumbnail(item?.poseRef?.url)} alt="" />
            </div>
        </div>
    )
    const modelImg = item?.person?.url && (
        <div className={styles.section}>
            {item?.keepPose ? null : <><p className={styles.label}>模特</p><p className={styles.value}>{
                item?.person?.custom ? "自定义模特" :
                    item?.person?.title?.split("-").pop()}</p></>}
            {!item?.keepPose && <div className={styles.imageList}><img src={Utils.getImgThumbnail(item?.person?.url)} alt="" /></div>}
        </div>
    )
    const bkgImg = item?.background?.url && (
        <div className={styles.section}>
            {
                item?.keepBkg ? null : <><p className={styles.label}>背景</p><p className={styles.value}>{
                    item?.background?.custom ? "自定义背景" :
                        item?.background?.title?.split("-").pop()}</p></>
            }
            {!item?.keepBkg && <div className={styles.imageList}><img src={Utils.getImgThumbnail(item?.background?.url)} alt="" /></div>}
        </div>
    )
    const shoesImg = (
        <div className={styles.section}>
            <p className={styles.label}>{item?.shoesRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <div className={styles.imageList}>
                <img src={Utils.getImgThumbnail(item?.shoesRef?.url)} alt="" />
            </div>
        </div>
    )
    // 搭配上身搭配圖
    const matchImages = (
        item?.matchImages && <div className={styles.section}>
            <p className={styles.label}>商品图</p>
            <div className={styles.imageList}>
                {item?.matchImages?.map((img, index) => (
                    <img
                        key={index}
                        src={Utils.getImgThumbnail(img?.url)}
                        className={selectedInputImg == img?.url ? styles.active : ''}
                        onClick={() => setSelectedInputImg(img?.url)}
                        alt=""
                    />
                ))}
            </div>
        </div>
    )
    // 搭配上身模特图
    const creativeRefImages = (
        item?.refImages?.length > 0 && <div className={styles.section}>
            <p className={styles.label}>商品图</p>
            <div className={styles.imageList}>
                {item?.refImages?.map((img, index) => {
                    const imageUrl = img?.url || img
                    return <img
                        key={`${imageUrl}-${index}`}
                        src={Utils.getImgThumbnail(imageUrl)}
                        className={selectedInputImg == imageUrl ? styles.active : ''}
                        onClick={() => setSelectedInputImg(imageUrl)}
                        alt=""
                    />
                })}
            </div>
        </div>
    )
    const modelTryonImg = item?.modelImage?.url && (
        <div className={styles.section}>
            <p className={styles.label}>模特图</p>
            <div className={styles.imageList}>
                <img
                    onClick={() => setSelectedInputImg(item?.modelImage?.url)}
                    className={selectedInputImg == item?.modelImage?.url ? styles.active : ''}
                    src={Utils.getImgThumbnail(item?.modelImage?.url)} alt="" />
            </div>
        </div>
    )

    const showConent = (
        item?.imageType == IMAGE_TYPE.CLOTHES ? (
            <>
                {title}
                {inputImg}
                {poseImg}
                {modelImg}
                {bkgImg}
                {modelProvider}
                {mode}
            </>
        ) : item?.imageType == IMAGE_TYPE.MODEL || item?.imageType == IMAGE_TYPE.BACKGROUND ?
            (
                <>
                    {title}
                    {inputImg}
                    {modelImg}
                    {bkgImg}
                    {item?.emoji && item?.imageType != IMAGE_TYPE.BACKGROUND ? modelEmoji : null}
                    {item?.skinRefine ? skinRefine : null}
                    {item?.relight > 0 ? relight : null}
                    {(item.relightMode && item.relight > 0) ? relightMode : null}
                    {resolutionAlignTitle}
                </>
            ) : item?.imageType == IMAGE_TYPE.SHOES ?
                (
                    <>
                        {title}
                        {inputImg}
                        {shoesImg}
                        {mode}
                    </>
                ) : item?.imageType == IMAGE_TYPE.MODEL_VIDEO ?
                    (
                        <>
                            {title}
                            {inputImg}
                            {mode}
                            {orientation}
                            {prompt}
                        </>
                    ) : item?.imageType == IMAGE_TYPE.IMAGE_TO_VIDEO ?
                        (
                            <>
                                {title}
                                {inputImg}
                                {mode}
                                {duration}
                                {prompt}
                            </>
                        ) : item?.imageType == IMAGE_TYPE.COMMODITYRECOLOR ?
                            (
                                <>
                                    {title}
                                    {recolor}
                                    {hdMode}
                                </>
                            ) : item?.imageType == IMAGE_TYPE.CLOTH_RECOLOR ?
                                (
                                    <>
                                        {title}
                                        {inputImg}
                                        {(item.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR ? recolor : simReColor)}
                                    </>
                                ) : item?.imageType == IMAGE_TYPE.COMMODITY ?
                                    (
                                        <>
                                            {title}
                                            {inputImg}
                                            {bkgImg}
                                            {mode}
                                        </>
                                    ) : item?.imageType == IMAGE_TYPE.POSE_TRYON ?
                                        (
                                            <>
                                                {title}
                                                {inputImg}
                                                {poseTryonImg}
                                                {hdMode}
                                            </>
                                        ) : item?.imageType == IMAGE_TYPE.GLASSES_TRYON || item?.imageType == IMAGE_TYPE.NECKLACE_TRYON ?
                                            (
                                                <>
                                                    {title}
                                                    {inputImg}
                                                    {glassesTryonImg}
                                                    {mode}
                                                </>
                                            ) : item?.imageType == IMAGE_TYPE.SIM_TRYON ?
                                                (
                                                    <>
                                                        {title}
                                                        {inputImg}
                                                        {simTryonImg}
                                                    </>
                                                ) : item?.imageType == IMAGE_TYPE.FUSION_WEAR ?
                                                    (
                                                        <>
                                                            {title}
                                                            {matchImages}
                                                            {modelTryonImg}
                                                            {mode}
                                                            {prompt}
                                                        </>
                                                ) : item?.imageType == IMAGE_TYPE.CREATIVE_IMAGE_GEN ?
                                                    (
                                                        <>
                                                            {title}
                                                            {creativeRefImages}
                                                            <div className={styles.section}>
                                                                <p className={styles.label}>生成模式</p>
                                                                <p className={styles.value}>{getCreativeImageModeLabel(item?.mode)}</p>
                                                            </div>
                                                            {prompt}
                                                        </>
                                                    ) : item?.imageType == IMAGE_TYPE.GRASS_PLANT ?
                                                        (
                                                            <>
                                                                {title}
                                                                {modelImg}
                                                                {bkgImg}
                                                                {mode}
                                                            </>
                                                        ) : item?.imageType == IMAGE_TYPE.AI_BEAUTY ? (
                                                            <>
                                                                {title}
                                                                {inputImg}
                                                                {relightMode2}
                                                            </>
                                                        ) :
                                                            <>
                                                                {title}
                                                                {inputImg}
                                                            </>

    )


    return (
        <>
            <div className={`${styles.ModelLeftCom} _beauty_scrollbar`}>
                {showConent}
            </div>
            <RefListModal ref={refListModalRef} onSelect={setSelectedInputImg} />
        </>

    )
}

export default ModelLeftCom
